import { Button, Row, Space, Typography } from 'antd';
import { FileUploadSpec } from '../../../../../../../../constants';
import { FileInfo, IdentityVerificationCaseV1UpdateInput } from '../../../../../../../../generated';
import { FilePreview } from '../../../../../../../shared/file-preview/file-preview';
import { IdCaseFileUploadButtonWithPreviewContainer } from '../../../../../../../shared/file-upload-button-with-preview/id-case-file-upload-button-with-preview.container';
import { AzureBlobResponse } from '../../../../../../../shared/file-upload/azure-upload';

interface CaseDetailsFilesProps {
  getFilePreviewDataLoading: boolean;
  idFormInfo: FileInfo;
  getFilePreviewDataError: Error;
  caseId: string;
  isEditingNotarizedIdForm: boolean;
  setIsEditingNotarizedIdForm: React.Dispatch<React.SetStateAction<boolean>>;
  handleUploadSuccess: (response: AzureBlobResponse, fieldName: string) => Promise<void>;
  getFilePreviewDataData: any;
  handleSave: () => void;
  updateIdentityVerificationCaseV1Loading: boolean;
  handleSaveAndComplete: () => void;
  uploadedData: IdentityVerificationCaseV1UpdateInput;
}

export const CaseDetailsFiles: React.FC<CaseDetailsFilesProps> = (props) => {
  return (
      <div className="flex flex-col gap-6 px-2">
          <div className="flex justify-between ">
            <Space direction="vertical" size={0}>
              {<Typography.Title level={5}>Id Form</Typography.Title>}
              <FilePreview fileUrl={props?.idFormInfo?.url ?? ''} fileName={props?.idFormInfo?.name ?? ''} fileType={props?.idFormInfo?.type ?? ''} isShowFileName={false} />
            </Space>
          </div>

        <div className="flex justify-between">
          <IdCaseFileUploadButtonWithPreviewContainer
            title={'Notarized Id Form'}
            buttonText={'Upload Revised Document'}
            caseId={props.caseId}
            fileName={FileUploadSpec.NotarizedIdForm.fileName}
            permittedContentTypes={FileUploadSpec.NotarizedIdForm.permittedContentTypes}
            permittedExtensions={FileUploadSpec.NotarizedIdForm.permittedExtensions}
            isPreviewOnly={!props?.isEditingNotarizedIdForm}
            setIsEditing={props?.setIsEditingNotarizedIdForm}
            onUploadSuccess={(response) => props?.handleUploadSuccess(response, FileUploadSpec.NotarizedIdForm.fieldName)}
            isShowFileName={false}
          />
          <Button
            type="primary"
            className="my-4"
            onClick={() => props?.setIsEditingNotarizedIdForm((prev) => !prev)}
            disabled={
              props?.getFilePreviewDataData?.identityVerificationCaseV1?.state !== 'revisionRequested' ||
              !props?.getFilePreviewDataData?.identityVerificationCaseV1 ||
              !props?.getFilePreviewDataData?.identityVerificationCaseV1?.revisionRequest?.requestedChanges?.requestUploadNotarizedIdForm
            }
          >
            {props?.isEditingNotarizedIdForm ? 'Editing' : 'Edit'}
          </Button>
        </div>
        <Row justify={'start'}>
          <Space size="large" direction="horizontal" style={{ display: props?.isEditingNotarizedIdForm ? 'flex' : 'none' }}>
            <Button type="default" onClick={props?.handleSave} loading={props?.updateIdentityVerificationCaseV1Loading} disabled={!props?.uploadedData}>
              Save
            </Button>
            <Button type="primary" onClick={props?.handleSaveAndComplete} loading={props?.updateIdentityVerificationCaseV1Loading}>
              Save and Complete
            </Button>
          </Space>
        </Row>
      </div>
  );
};
